import { Button } from "@mui/material";
import { useEffect, useState } from "react";
import { makeStyles } from "@mui/styles";
import { rem } from "assets/js/common";
import KaKaoMap from "./kakao-map";
import { CopyToClipboard } from "react-copy-to-clipboard";
import AlertComplete from "components/ui/alert-complete";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  wayToCome: {
    "& .map-info": {
      padding: `${rem(24)} ${rem(30)} ${rem(60)}`,
      "& .tit": {
        fontSize: rem(15),
        fontWeight: 700,
      },
      "& .map-addr": {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        "& .location": {
          fontSize: rem(13),
          padding: `${rem(6)} ${rem(90)} 0 0`,
          lineHeight: rem(20),
        },
        "& .copy-btn": {
          color: "#8E8E8E",
          fontSize: rem(14),
          textDecoration: "underline",
          textUnderlinePosition: "under",
          minWidth: "auto",
        },
      },
    },
  },
}));

export default function WayToCome(props) {
  const classes = useStyles();
  const history = useHistory();
  const location = props.location;

  const [open, setOpen] = useState(false);

  const handleAlertOpen = () => {
    setOpen(true);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  window.appBackKeyHandle = () => {
    if (open) {
      handleAlertClose();
    } else {
      history.goBack();
    }
  };

  return (
    <div className={classes.wayToCome}>
      <KaKaoMap offsetX={location.xcrdn} offsetY={location.ycrdn} />
      <div className="map-info">
        <div className="tit">{location.nm}</div>
        <div className="map-addr">
          <div className="location">{location.addr}</div>
          <CopyToClipboard
            text={location.addr}
            onCopy={() => handleAlertOpen()}
          >
            <span className="copy-btn">주소복사</span>
          </CopyToClipboard>
          <AlertComplete
            open={open}
            handleAlertClose={handleAlertClose}
            text={"주소가 복사되었습니다."}
            action={handleAlertClose}
          />
        </div>
      </div>
    </div>
  );
}
